import React from 'react';
import {
  Button,
  Modal,
  Autosuggest,
  Table,
  SpaceBetween
} from '@amzn/awsui-components-react-v3';
import { SaveReportColumnDefinitions } from '../../constants/constants';
import { deepClone} from '../../utilities';

export class ReportSaveWindow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      nameError: false,
      errorText: '',
      params: {},
      value: '',
    };
    this.columnDefinitions = SaveReportColumnDefinitions;
    this.tableItems = [];

    this.reports = [];
    for (let report of this.props.reportsList) {
      this.reports.push(report['name']);
    }
    this.options = [];
    for (let report of this.reports) {
      this.options.push({ value: report, disabled: true });
    }
    this.options = [{ label: 'Existing Reports', options: this.options }];
  }

  componentWillMount = () => {
    this.setState({ params: deepClone(this.props.params) });
  };

  componentDidMount() {
    let params = this.state.params;
    {params.rollup && this.paramLine('Rollup : ', params.rollup.toUpperCase())}
    {params.region && this.paramLine('Region : ', params.region.toUpperCase())}
    {params.marketplace && this.paramLine('Marketplace(s) : ', params.marketplace)}
    {params.marketplace && params.marketplace.includes(',') && params.aggregatedMarketplaces === true && this.paramLine('Aggregated Marketplaces : ', 'Yes')}
    {params.marketplace && params.marketplace.includes(',') && params.aggregatedMarketplaces === false && this.paramLine('Aggregated Marketplaces : ', 'No')}
    {params.timeFrame && this.paramLine('TimeFrame : ', params.timeFrame)}
    {params.timeFrame.includes(',') && params.aggregatedTimeFrames && this.paramLine('Aggregated TimeFrames : ', 'Yes')}
    {params.timeFrame.includes(',') && params.aggregatedTimeFrames === false && this.paramLine('Aggregated TimeFrames : ', 'No')}
    {this.paramLine('Channel : ', params.channel)}
    {params.report.toUpperCase() !== 'MARKETPLACE' && params.productLines && this.paramLine('Product Line(s) : ', params.productLines)}
    {params.report.toUpperCase() === 'COMPONENT' && params.columnSets && this.paramLine('Benchmark(s) : ', params.columnSets)}
    {(params.report.toUpperCase() === 'COMPONENT' || params.report.toUpperCase() === 'PL') && params.snapshots && this.paramLine('Snapshot(s) : ', this.displaySnapshots())}
    {params.report.toUpperCase() === 'PL' && params.component && this.paramLine('Component : ', params.component)}
    {params.report.toUpperCase() === 'COMPONENT' && params.currency && this.paramLine('Currency : ', params.currency)}
  }

  validate = () => {
    for (let report of this.reports) {
      if (report === this.state.name) {
        this.setState({ nameError: true, errorText: 'Report cannot share a name with any of your other reports' });
        return false;
      }
    }
    this.setState({ nameError: false, errorText: '' });
    return true;
  };

  status = () => {
    if (this.state.nameError) {
      return 'error';
    } else {
      return undefined;
    }
  };

  onChange = (event) => {
    if (event.detail.value !== undefined) {
      this.setState({ value: event.detail.value });
    } else {
      this.setState({ value: "" });
    }
    this.setState({ name: event.detail.value }, () => {
      this.validate();
    });
  };

  onSubmit = () => {
    if (this.validate()) {
      let params = deepClone(this.state.params);
      params['name'] = this.state.name;
      params['id'] = encodeURIComponent(this.props.user + '-' + this.state.name);
      this.props.onSubmit(params);
      this.setState({ name: '', nameError: false, errorText: '' });
    }
  };

  onCancel = () => {
    this.setState({ name: '', nameError: false, errorText: '' });
    this.props.onCancel();
  };

  displaySnapshots = () => {
    let output = this.state.params.snapshots[0].id;
    for (let i = 1; i < this.state.params.snapshots.length; i++) {
      output = output + "," + this.state.params.snapshots[i].id;
    }
    return output;
  };

  paramLine = (label, param) => {
    param = param.replace(/,/g, ', ');
    this.tableItems.push ({
       "name": <b>{label}</b>,
       "value": param
    })
  };

  displayTable = () => {
    return(
      <Table
        loadingText="Loading resources"
        columnDefinitions={ this.columnDefinitions }
        items={ this.tableItems }
       />
    );
  };

  render() {
    const { value, params } = this.state;
    return (
      <Modal
        id='save-report-window'
        visible={true}
        size="medium"
        header={'Save Report'}
        onDismiss={this.onCancel}
        footer={
          <span className="awsui-util-f-r">
            <SpaceBetween direction="horizontal" size="xs">
            <Button onClick={this.onCancel} >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={this.onSubmit}
              disabled={!this.state.name || this.state.nameError}
              data-cy="report-save-button-in-dialog"
            >
                Save
            </Button>
            </SpaceBetween>
          </span>
        }
      >
          <div>
            <h4 className="awsui-util-t-c">
              {params.report.toUpperCase()} REPORT - {this.props.formatDate(params.timeFrame)}
              <br />
              <br />
            </h4>
            <h4 className="awsui-util-t-c">
              Name: <br />
              <br />
              <Autosuggest
                value={value}
                placeholder="Enter report name"
                options={this.options}
                onChange={this.onChange}
                statusType={this.status()}
                enteredTextLabel={value => `Use: "${value}"`}
                errorText={this.state.errorText}
                //autoFocus={true}
                empty="No existing reports found with this name"
                data-cy="save-report-name"
              />
            </h4>
            <br />
            {this.displayTable()}
          </div>
      </Modal>

    );
  }
}

export default ReportSaveWindow;



// WEBPACK FOOTER //
// ./src/components/content/report_save_window.jsx